module.exports = __webpack_public_path__ + "static/media/15UN-Habitat13.a4b3c70d.jpg";